import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import i18next, { t } from 'i18next';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react';

class CONTRACT_SERVICES_STATUS extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent?.items.length > 0 ? this.props.inputParam_ComponentContent : [{
        nombrePartida: t('data-lang-lbl-dataname') + " 1",
        partidaMontoBase: 2300.015558,
        epMesMontoPago: 2225.015558,
        epMesSaldo: 75,
        porcentajeUso: 92
      },{
        nombrePartida: t('data-lang-lbl-dataname') + " 2",
        partidaMontoBase: 900,
        epMesMontoPago: 107,
        epMesSaldo: 293,
        porcentajeUso: 12
      }]) : [{
        nombrePartida: t('data-lang-lbl-dataname') + " 1",
        partidaMontoBase: 0,
        epMesMontoPago: 0,
        epMesSaldo: 0,
        porcentajeUso: 0
      },{
        nombrePartida: t('data-lang-lbl-dataname') + " 2",
        partidaMontoBase: 0,
        epMesMontoPago: 0,
        epMesSaldo: 0,
        porcentajeUso: 0
      }], 
    };
  }
  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_ComponentContent: PropTypes.object,
    inputParam_UseFake: PropTypes.bool,
    inputParam_BoardStructure: PropTypes.object,
    inputParam_Container: PropTypes.object,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_ComponentContent: null,
    inputParam_BoardStructure: null,
    inputParam_Container: null,
    inputParam_UseFake: false
  };

  renderComponent() {
    return  <Row className='px-3 h-100' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
              <Col className='my-auto p-0'>
                {
                  this.state?.items && this.state?.items.length > 0 && this.state.items.map((x, index) => (
                    <div key={index} className='border-bottom mb-1 d-flex'>
                      <div className='px-1 text-start w-18 border-end' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          <TooltipHost
                            content={x.nombrePartida}
                          >
                            {x.nombrePartida}
                          </TooltipHost>
                      </div>
                      <div className='px-1 text-end w-19'>{x.partidaMontoBase !== null ? parseFloat(x.partidaMontoBase.toFixed(2)).toLocaleString(i18next.language) : '--'}</div>
                      <div className='px-1 text-end w-19'>{x.epMesMontoPago !== null ? parseFloat(x.epMesMontoPago.toFixed(2)).toLocaleString(i18next.language) : '--'}</div>
                      <div className='px-1 text-end w-19'>{x.epMesSaldo !== null ? parseFloat(x.epMesSaldo.toFixed(2)).toLocaleString(i18next.language) : '--'}</div>
                      <div className='px-1 text-end w-14 my-auto'>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{width: `${x.porcentajeUso}%`}} aria-valuenow={x.porcentajeUso} aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                      <div className='px-1 text-end w-11'>{x.porcentajeUso !== null ? parseFloat(x.porcentajeUso.toFixed(2)).toLocaleString(i18next.language) + '%': '--'}</div>
                    </div>
                  ))
                }
                <div className='border-bottom mb-1 d-flex'>
                  <div className='px-1 text-start w-18 border-end' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      <b>Total</b>
                  </div>
                  <div className='px-1 text-end w-19'><b>{this.state.items.length > 0 ? parseFloat(this.state.items.reduce((acumulador, item) => acumulador + item.partidaMontoBase, 0).toFixed(2)).toLocaleString(i18next.language) : 0}</b></div>
                  <div className='px-1 text-end w-19'><b>{this.state.items.length > 0 ? parseFloat(this.state.items.reduce((acumulador, item) => acumulador + item.epMesMontoPago, 0).toFixed(2)).toLocaleString(i18next.language) : 0}</b></div>
                  <div className='px-1 text-end w-19'><b>{this.state.items.length > 0 ? parseFloat(this.state.items.reduce((acumulador, item) => acumulador + item.epMesSaldo, 0).toFixed(2)).toLocaleString(i18next.language) : 0}</b></div>
                  <div className='px-1 text-end w-14 my-auto'>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{width: `${this.state.items.length > 0 ? parseFloat(this.state.items.reduce((acumulador, item) => acumulador + item.porcentajeUso, 0).toFixed(2)).toLocaleString(i18next.language) : 0}%`}}
                        aria-valuenow={this.state.items.length > 0 ? parseFloat(this.state.items.reduce((acumulador, item) => acumulador + item.porcentajeUso, 0).toFixed(2)).toLocaleString(i18next.language) : 0}
                        aria-valuemin="0"
                        aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                  <div className='px-1 text-end w-11'><b>{(this.state.items.length > 0 ? this.state.items.reduce((acumulador, item) => acumulador + item.porcentajeUso, 0) : 0) + '%'}</b></div>
                </div>
              </Col>
            </Row>
  }

  render() {
    return (
      <>
      {
        !this.props.inputParam_UseFake &&
        <Card className='h-100'>
          {
            !this.props.inputParam_HideHeader &&
            <Card.Header className="card-header-compact">
              <Card.Title className="d-flex justify-content-between">
                <b>{ this.state !== null ? (this.state.boardComponentTitle ?? t('data-lang-boxname-itemdetails')) : t('data-lang-boxname-itemdetails')}</b>
                <div className='toolbar d-flex'>
                  <HEADER_TOOLBAR
                    inputParam_BoardStructure={this.props.inputParam_BoardStructure}
                    inputParam_Container={this.props.inputParam_Container}
                  />
                </div>
              </Card.Title>
            </Card.Header>
          }
          <Card.Body className='px-1 py-0 h-100'>
            {this.renderComponent()}
          </Card.Body>
        </Card>
      }
      {this.props.inputParam_UseFake && this.renderComponent()}
      </>
    );
  }
}

export default CONTRACT_SERVICES_STATUS;